import { useState, type FormEvent } from "react";
import { FileText, ReceiptText } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input, Label, Select } from "@/components/ui/form";

export function BillingPage() {
  const [bookingId, setBookingId] = useState("");
  const [type, setType] = useState<"invoice" | "receipt">("invoice");
  const [error, setError] = useState<string | null>(null);

  function openDocument(event: FormEvent) {
    event.preventDefault();
    const id = Number(bookingId);
    if (!Number.isInteger(id) || id <= 0) { setError("Enter a valid positive booking ID."); return; }
    setError(null);
    window.open(`/api/v1/bookings/${id}/documents/${type}`, "_blank", "noopener,noreferrer");
  }

  return <div className="mx-auto max-w-3xl space-y-6">
    <div><p className="text-sm font-semibold text-primary">Billing operations</p><h1 className="page-heading mt-1">Receipts and invoices</h1><p className="mt-1 text-sm text-muted-foreground">Generate a printable, signed document from a booking’s current immutable billing snapshot.</p></div>
    <Card>
      <CardHeader><CardTitle className="flex items-center gap-2"><FileText className="h-5 w-5" /> Open document</CardTitle></CardHeader>
      <CardContent><form onSubmit={openDocument} className="grid gap-4 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
         <div className="space-y-2"><Label required htmlFor="billing-booking">Booking ID</Label><Input id="billing-booking" required aria-invalid={!!error} type="number" min="1" value={bookingId} onChange={(event) => { setBookingId(event.target.value); setError(null); }} />{error && <p role="alert" className="text-xs text-destructive">{error}</p>}</div>
         <div className="space-y-2"><Label required htmlFor="billing-document">Document</Label><Select id="billing-document" value={type} onChange={(event) => setType(event.target.value as typeof type)}><option value="invoice">Invoice</option><option value="receipt">Receipt</option></Select></div>
        <Button type="submit"><ReceiptText className="h-4 w-4" /> Generate</Button>
      </form></CardContent>
    </Card>
  </div>;
}
